import { Astro, AxEngage, Calendly, Crisp, Firebase, Gatsby, GoogleAnalytics, GoogleCloud, Gsap, Netlify, Node, OpenAi, Postmark, React, Sanity, Snipcart, Stripe, ThreeJs, Webflow, Wordpress } from '../../../images/service-pages/development/technologies'

const iconMapper = {
  'Astro': Astro,
  'AX Engage': AxEngage,
  'Calendly': Calendly,
  'Crisp': Crisp,
  'Firebase': Firebase,
  'Gatsby': Gatsby,
  'Google Analytics': GoogleAnalytics,
  'Google Cloud': GoogleCloud,
  'GSAP': Gsap,
  'Netlify': Netlify,
  'Node': Node,
  'OpenAI': OpenAi,
  'Postmark': Postmark,
  'React': React,
  'Sanity': Sanity,
  'Snipcart': Snipcart,
  'Stripe': Stripe,
  'ThreeJS': ThreeJs,
  'Webflow': Webflow,
  'Wordpress': Wordpress
} 

export default iconMapper;